import { __assign } from "tslib";
import React from 'react';
import { View } from 'react-native';
import { textStyle } from '../../v2/theme';
import { PnmacSelect, PnmacTextInput, PnmacText } from 'pnmac-universal-components';
import { checkForAllNumbers, checkForAllNumbersWBetweenMinLengthAndMaxLength, isEmptyOrSpaces, checkIfStringHasSpecialChar } from '../../utils.js';
export default function BankAccountGrid(_a) {
  var disabled = _a.disabled,
    isOtp = _a.isOtp,
    translations = _a.translations,
    bankAccount = _a.bankAccount,
    onChange = _a.onChange,
    layout = _a.layout,
    matches = _a.matches,
    errors = _a.errors,
    setErrors = _a.setErrors;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: 15,
      marginBottom: 15,
      marginLeft: matches.small ? 0 : 15
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
    for: "txtBankRoutingAndTransitNumber"
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: textStyle.defaultTextDescription,
    nativeID: "lblRoutingAndTransitNumber"
  }, translations.RoutingAndTransitNumber)) : /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblRoutingAndTransitNumber',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      paddingRight: 10
    })
  }, translations.RoutingAndTransitNumber)), /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, (errors === null || errors === void 0 ? void 0 : errors.bankRoutingNumberError) ? /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblRoutingAndTransitNumberError',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      color: "red"
    })
  }, "Routing and Transit Number should be valid and 9 digits long") : null, /*#__PURE__*/React.createElement(PnmacTextInput, {
    accessibilityLabel: "Routing and transit number",
    nativeID: "txtBankRoutingAndTransitNumber",
    disabled: !isOtp && !disabled,
    disabledColored: true,
    name: "bankRoutingNumber",
    mode: "outlined",
    style: {
      width: '100%'
    },
    value: bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankRoutingNumber,
    placeholder: translations === null || translations === void 0 ? void 0 : translations.RoutingAndTransitNumber,
    maxLength: 9,
    onBlur: function () {
      if (isEmptyOrSpaces(bankAccount.bankRoutingNumber) || !checkForAllNumbers(bankAccount.bankRoutingNumber, 9)) {
        setErrors(__assign(__assign({}, errors), {
          bankRoutingNumberError: true
        }));
      } else if (checkForAllNumbers(bankAccount.bankRoutingNumber)) {
        onChange(bankAccount.bankRoutingNumber, "bankRoutingNumber");
        if (checkForAllNumbers(bankAccount.bankRoutingNumber, 9)) {
          // turn to POST
          fetch("".concat(layout.pennyHomeUrl, "api/payment/ValidateRoutingNumber?routingnumber=").concat(bankAccount === null || bankAccount === void 0 ? void 0 : bankAccount.bankRoutingNumber), {
            method: 'POST',
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": "Bearer ".concat(layout.token)
            }
          }).then(function (res) {
            return res.json();
          }).then(function (isValidRoutingNumber) {
            if (isValidRoutingNumber) {
              setErrors(__assign(__assign({}, errors), {
                bankRoutingNumberError: false
              }));
            } else {
              setErrors(__assign(__assign({}, errors), {
                bankRoutingNumberError: true
              }));
            }
          });
        }
      } else {
        setErrors(__assign(__assign({}, errors), {
          bankRoutingNumberError: false
        }));
      }
    },
    onChangeText: function (text) {
      if (checkForAllNumbers(text)) {
        onChange(text, "bankRoutingNumber");
      }
    }
  }))), /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: 15,
      marginBottom: 15,
      marginLeft: matches.small ? 0 : 15
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
    for: "txtBankAccountNumber"
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: textStyle.defaultTextDescription,
    nativeID: "lblBankAccountNumber"
  }, translations.BankAccountNumber)) : /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblBankAccountNumber',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      paddingRight: 10
    })
  }, translations.BankAccountNumber)), /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, (errors === null || errors === void 0 ? void 0 : errors.bankAccountNumberError) ? /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblBankAccountNumberError',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      color: "red"
    })
  }, "The Bank Account Number must be between 5 and 17 characters long") : null, /*#__PURE__*/React.createElement(PnmacTextInput, {
    accessibilityLabel: "Bank account number",
    nativeID: "txtBankAccountNumber",
    disabled: !isOtp && !disabled || errors.bankRoutingNumberError,
    disabledColored: true,
    mode: "outlined",
    minLength: 5,
    maxLength: 17,
    name: "bankAccountNumber",
    style: {
      width: '100%'
    },
    value: bankAccount.bankAccountNumber,
    placeholder: translations === null || translations === void 0 ? void 0 : translations.BankAccountNumber,
    onFocus: function () {
      if (!checkForAllNumbers(bankAccount.bankAccountNumber)) {
        onChange("", "bankAccountNumber");
      }
    },
    onChangeText: function (text) {
      if (checkForAllNumbers(text)) {
        onChange(text, "bankAccountNumber");
      }
    },
    onBlur: function () {
      if (isEmptyOrSpaces(bankAccount.bankAccountNumber) || !checkForAllNumbersWBetweenMinLengthAndMaxLength(bankAccount.bankAccountNumber, 5, 17)) {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNumberError: true
        }));
      } else if (!isEmptyOrSpaces(bankAccount.confirmAccountNumber) && bankAccount.bankAccountNumber != bankAccount.confirmAccountNumber) {
        setErrors(__assign(__assign({}, errors), {
          confirmAccountNumberError: true
        }));
      } else {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNumberError: false,
          confirmAccountNumberError: false
        }));
      }
    }
  }))), (isOtp || disabled) && /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: 15,
      marginBottom: 15,
      marginLeft: matches.small ? 0 : 15
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, !layout.mobile ? /*#__PURE__*/React.createElement("label", {
    for: "txtConfirmAccountNumber"
  }, /*#__PURE__*/React.createElement(PnmacText, {
    style: textStyle.defaultTextDescription,
    nativeID: "lblConfirmAccountNumber"
  }, translations.ConfirmAccountNumber)) : /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblConfirmAccountNumber',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      paddingRight: 10
    })
  }, translations.ConfirmAccountNumber)), /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, (errors === null || errors === void 0 ? void 0 : errors.confirmAccountNumberError) ? /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblConfirmAccountNumberError',
    style: {
      color: "red"
    }
  }, "Please verify your account number.") : null, /*#__PURE__*/React.createElement(PnmacTextInput, {
    accessibilityLabel: "Confirm account number",
    nativeID: "txtConfirmAccountNumber",
    mode: "outlined",
    style: {
      width: '100%'
    },
    maxLength: 17,
    name: "confirmAccountNumber",
    value: bankAccount.confirmAccountNumber,
    placeholder: translations === null || translations === void 0 ? void 0 : translations.confirmAccountNumber,
    disabled: errors.bankRoutingNumberError,
    onFocus: function () {
      if (!checkForAllNumbers(bankAccount.confirmAccountNumber)) {
        onChange("", "confirmAccountNumber");
      }
    },
    onChangeText: function (text) {
      if (checkForAllNumbers(text)) {
        onChange(text, "confirmAccountNumber");
      }
    },
    onBlur: function () {
      if (isEmptyOrSpaces(bankAccount.confirmAccountNumber) || bankAccount.bankAccountNumber != bankAccount.confirmAccountNumber) {
        setErrors(__assign(__assign({}, errors), {
          confirmAccountNumberError: true
        }));
      } else {
        setErrors(__assign(__assign({}, errors), {
          confirmAccountNumberError: false
        }));
      }
    }
  }))), (isOtp || disabled) && /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: 15,
      marginBottom: 15,
      marginLeft: matches.small ? 0 : 15
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblBankAccountType',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      paddingRight: 10
    })
  }, translations.BankAccountType)), /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, (errors === null || errors === void 0 ? void 0 : errors.bankAccountTypeError) ? /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblBankAccountTypeError',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      color: "red"
    })
  }, "Please enter a ", translations.BankAccountType) : null, /*#__PURE__*/React.createElement(View, {
    accessibilityLabel: "Bank account type"
  }, /*#__PURE__*/React.createElement(PnmacSelect, {
    accessibilityLabel: "Bank account type",
    useNativeAndroidPickerStyle: Platform.select({
      android: false,
      web: true,
      ios: true
    }),
    key: 'paymentSelect1',
    idTag1: 'dropDownDocType',
    idTag2: 'bankAccountType',
    disabled: errors.bankRoutingNumberError,
    Icon: layout.mobile && Platform.OS === 'ios' ? function () {
      return /*#__PURE__*/React.createElement(Image, {
        style: {
          marginTop: 3,
          marginRight: 5,
          width: 12,
          height: 8
        },
        source: require("../../assets/expand-icon.png")
      });
    } : function () {
      return null;
    },
    onValueChange: function (value) {
      if ("Select an item..." == value) {
        setErrors(__assign(__assign({}, errors), {
          bankAccountTypeError: true
        }));
      } else {
        if (parseInt(value) > 0) {
          setErrors(__assign(__assign({}, errors), {
            bankAccountTypeError: false
          }));
          onChange(value, "bankAccountType");
        }
      }
    },
    style: {
      viewContainer: __assign({}, layout.mobile ? {
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "white",
        borderRadius: 10,
        height: 50,
        borderColor: '#707070',
        borderWidth: 1
      } : null),
      inputAndroid: {
        color: "#707070",
        width: '100%',
        paddingLeft: 10,
        paddingRight: 20
      },
      inputIOS: {
        color: "#707070",
        paddingLeft: 10,
        paddingRight: 20
      }
    },
    value: parseInt(bankAccount.bankAccountType) || '',
    items: [{
      key: "Checking",
      label: "Checking Account",
      value: 201286
    }, {
      key: "Saving",
      label: "Savings Account",
      value: 201287
    }]
  })))), /*#__PURE__*/React.createElement(View, {
    style: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: 15,
      marginBottom: 15,
      marginLeft: matches.small ? 0 : 15
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblBankAccountName',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      paddingRight: 10
    })
  }, translations.NameOnBankAccount)), /*#__PURE__*/React.createElement(View, {
    style: {
      flex: 1
    }
  }, (errors === null || errors === void 0 ? void 0 : errors.bankAccountNameError) ? /*#__PURE__*/React.createElement(PnmacText, {
    idTag1: 'lblBankAccountNameError',
    style: __assign(__assign({}, textStyle.defaultTextDescription), {
      color: "red"
    })
  }, "AccountName must be a maximum of 22 characters. Tip: Use only one account holder name. If longer than 22 characters, try shortening from the end of the last name.") : null, /*#__PURE__*/React.createElement(PnmacTextInput, {
    accessibilityLabel: "Bank account name",
    nativeID: "txtBankAccountName",
    disabled: !isOtp && !disabled || errors.bankRoutingNumberError,
    disabledColored: true,
    mode: "outlined",
    minLength: 1,
    maxLength: 22,
    style: {
      width: '100%'
    },
    value: bankAccount.bankAccountName,
    onChangeText: function (text) {
      if (checkIfStringHasSpecialChar(text)) {
        onChange(text, "bankAccountName");
      }
    },
    onBlur: function () {
      if (isEmptyOrSpaces(bankAccount.bankAccountName)) {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNameError: true
        }));
      } else {
        setErrors(__assign(__assign({}, errors), {
          bankAccountNameError: false
        }));
      }
    }
  }))));
}